// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pgGH2","top":"styles_top__1JBPd","left":"styles_left__2ZkMS","description":"styles_description__2jiRY"};